import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppsRoutingModule } from './apps-routing.module';
import { FormatPipeModule } from '../../format-pipe/format-pipe.module';



@NgModule({
  imports: [
    AppsRoutingModule,
    CommonModule,
    FormatPipeModule
  ],
  declarations: [
    
  ]
})
export class AppsModule { }
